// 260703nrai: Gmail-style inbox list + detail pane
// 260709nrai: bulk actions, dynamic counters, maximize modal

function messagesInboxTabShowLoading(tabKey) {
  $(`#messages_inbox_panel_${tabKey}_loading`).show();
  $(`#messages_inbox_panel_${tabKey}_content`).hide();
}

function messagesInboxTabHideLoading(tabKey) {
  $(`#messages_inbox_panel_${tabKey}_loading`).hide();
  $(`#messages_inbox_panel_${tabKey}_content`).show();
}

function messagesInboxShowInlineLoading(loadingEl, contentEl) {
  if (loadingEl) loadingEl.style.display = '';
  if (contentEl) contentEl.style.display = 'none';
}

function messagesInboxHideInlineLoading(loadingEl, contentEl) {
  if (loadingEl) loadingEl.style.display = 'none';
  if (contentEl) contentEl.style.display = '';
}

function messagesInboxExtractListHtml(html) {
  const template = document.createElement('div');
  template.innerHTML = html;
  const meta = template.querySelector('.messages-inbox-list-meta');
  const info = meta
    ? { hasMore: meta.dataset.hasMore === '1', page: parseInt(meta.dataset.page, 10) || 1 }
    : null;
  if (meta) meta.remove();
  return { html: template.innerHTML, info };
}

function messagesInboxUpdateLoadMore(root, info) {
  const listPanel = root.querySelector('[data-messages-inbox-list]');
  if (!listPanel) return;

  let wrap = root.querySelector('.messages-inbox-load-more-wrap');
  if (!info || !info.hasMore) {
    wrap?.remove();
    return;
  }

  if (!wrap) {
    wrap = document.createElement('div');
    wrap.className = 'messages-inbox-load-more-wrap';
    wrap.innerHTML = '<a href="#" class="clickable_text messages-inbox-load-more">Weitere laden</a>';
    listPanel.parentElement.appendChild(wrap);
  }

  const loadMoreLink = wrap.querySelector('.messages-inbox-load-more');
  loadMoreLink.dataset.page = String(info.page + 1);
}

function messagesInboxBuildListParams(root, searchForm, page) {
  const params = new URLSearchParams(new FormData(searchForm));
  params.set('page', String(page || 1));
  return params;
}

function messagesInboxCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
}

function messagesInboxApplyStats(root, stats) {
  if (!stats) return;

  // 260722nrai: page_title renders a bare <h1> (no .page_title / #page_title wrapper)
  const pageTitle = document.querySelector('h1')
    || document.querySelector('.page_title h1, #page_title h1');
  if (pageTitle && stats.inbox_title) {
    pageTitle.textContent = stats.inbox_title;
  }

  // Keep sticky menubar chip in sync when scrolled past the H1
  const stickyTitle = document.getElementById('menubar_page_title');
  if (stickyTitle && stats.inbox_title) {
    stickyTitle.textContent = stats.inbox_title;
  }

  if (stats.filters_html) {
    const existing = root.querySelector('[data-messages-inbox-filters]');
    if (existing) {
      const template = document.createElement('div');
      template.innerHTML = stats.filters_html;
      const replacement = template.querySelector('[data-messages-inbox-filters]') || template.firstElementChild;
      if (replacement) existing.replaceWith(replacement);
    }
  }
}

function messagesInboxFetchStats(root) {
  const inboxTab = root.dataset.inboxTab;
  const searchForm = root.querySelector('.messages-inbox-search-form');
  const params = new URLSearchParams();
  params.set('tab', inboxTab);
  if (root.dataset.unreadOnly === 'true') params.set('unread_only', 'true');
  if (root.dataset.autoSwitched === '1') params.set('auto_switched', 'true');
  if (searchForm) {
    const search = searchForm.querySelector('.messages-inbox-search-input')?.value?.trim();
    if (search) params.set('search', search);
  }

  return fetch(`/messages/inbox/stats?${params.toString()}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then((response) => response.json())
    .then((stats) => {
      messagesInboxApplyStats(root, stats);
      return stats;
    })
    .catch(() => null);
}

function messagesInboxReadPreviewStats(detailPanel) {
  const node = detailPanel.querySelector('.messages-inbox-preview-stats');
  if (!node) return null;
  try {
    return JSON.parse(node.textContent || '{}');
  } catch {
    return null;
  }
}

function messagesInboxUpdateBulkToolbar(root) {
  const toolbar = root.querySelector('.messages-inbox-bulk-toolbar');
  const listPanel = root.querySelector('[data-messages-inbox-list]');
  if (!toolbar || !listPanel) return;

  const checkboxes = Array.from(listPanel.querySelectorAll('.messages-inbox-row-checkbox-input'));
  const checked = checkboxes.filter((box) => box.checked);
  const actionsWrap = toolbar.querySelector('.messages-inbox-bulk-actions');
  const selectAll = toolbar.querySelector('.messages-inbox-select-all');
  const markReadBtn = toolbar.querySelector('.messages-inbox-bulk-mark-read');
  const markUnreadBtn = toolbar.querySelector('.messages-inbox-bulk-mark-unread');

  if (selectAll) {
    if (checked.length === 0) {
      selectAll.checked = false;
      selectAll.indeterminate = false;
    } else if (checked.length === checkboxes.length) {
      selectAll.checked = true;
      selectAll.indeterminate = false;
    } else {
      selectAll.checked = false;
      selectAll.indeterminate = true;
    }
  }

  if (actionsWrap) {
    actionsWrap.hidden = checked.length === 0;
  }

  if (root.dataset.inboxTab === 'in') {
    const hasUnread = checked.some((box) => box.dataset.mfuStatus === 'unread');
    const hasRead = checked.some((box) => box.dataset.mfuStatus === 'read');
    if (markReadBtn) markReadBtn.hidden = !hasUnread;
    if (markUnreadBtn) markUnreadBtn.hidden = !hasRead;
  }
}

function messagesInboxOpenMaximizeModal(root, detailPanel) {
  const modal = document.getElementById('messages_inbox_maximize_modal');
  if (!modal || !detailPanel) return;

  const subject = detailPanel.querySelector('.messages-inbox-detail-subject-text')?.textContent?.trim()
    || detailPanel.querySelector('.messages-inbox-detail-subject')?.textContent?.trim()
    || '';
  const meta = detailPanel.querySelector('.messages-inbox-detail-meta')?.innerHTML || '';
  const body = detailPanel.querySelector('.messages-inbox-detail-body')?.innerHTML || '';

  modal.querySelector('.messages-inbox-maximize-subject').textContent = subject;
  modal.querySelector('.messages-inbox-maximize-meta').innerHTML = meta;
  modal.querySelector('.messages-inbox-maximize-body').innerHTML = body;

  if (window.jQuery && jQuery.fn.foundation) {
    jQuery(modal).foundation('reveal', 'open');
  } else {
    modal.style.display = 'block';
    modal.classList.add('open');
  }
}

function messagesInboxRunBulkAction(root, bulkAction) {
  const listPanel = root.querySelector('[data-messages-inbox-list]');
  const listLoading = root.querySelector('[data-messages-inbox-list-loading]');
  const detailPanel = root.querySelector('[data-messages-inbox-detail]');
  const inboxTab = root.dataset.inboxTab;
  const messageIds = Array.from(listPanel.querySelectorAll('.messages-inbox-row-checkbox-input:checked'))
    .map((box) => box.dataset.messageId)
    .filter(Boolean);

  if (!messageIds.length) return Promise.resolve();

  messagesInboxShowInlineLoading(listLoading, listPanel);

  return fetch('/messages/inbox/bulk', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': messagesInboxCsrfToken(),
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      tab: inboxTab,
      bulk_action: bulkAction,
      message_ids: messageIds
    })
  })
    .then((response) => response.json())
    .then((payload) => {
      if (payload.list_html) {
        const extracted = messagesInboxExtractListHtml(payload.list_html);
        listPanel.innerHTML = extracted.html;
        messagesInboxUpdateLoadMore(root, extracted.info);
      }
      messagesInboxApplyStats(root, payload);
      if (detailPanel) {
        detailPanel.innerHTML = '<p class="smallinfo messages-inbox-placeholder">Nachricht auswählen…</p>';
      }
      messagesInboxUpdateBulkToolbar(root);
    })
    .finally(() => {
      messagesInboxHideInlineLoading(listLoading, listPanel);
    });
}

function initMessagesInbox(root) {
  if (root && !root.matches?.('[data-messages-inbox]')) {
    root = root.querySelector?.('[data-messages-inbox]') || root;
  }
  root = root || document.querySelector('[data-messages-inbox]');
  if (!root) return;

  const detailPanel = root.querySelector('[data-messages-inbox-detail]');
  const listPanel = root.querySelector('[data-messages-inbox-list]');
  const detailLoading = root.querySelector('[data-messages-inbox-detail-loading]');
  const listLoading = root.querySelector('[data-messages-inbox-list-loading]');
  if (!detailPanel || !listPanel) return;

  const selectedId = root.dataset.selectedId;
  const inboxTab = root.dataset.inboxTab;
  const searchForm = root.querySelector('.messages-inbox-search-form');
  const searchInput = root.querySelector('.messages-inbox-search-input');
  let searchDebounceTimer = null;

  function loadPreview(url, row) {
    if (!detailPanel || !url) return;

    messagesInboxShowInlineLoading(detailLoading, detailPanel);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.text())
      .then((html) => {
        detailPanel.innerHTML = html;
        listPanel.querySelectorAll('.messages-inbox-row.selected').forEach((element) => element.classList.remove('selected'));
        if (row) row.classList.add('selected');
        if (row && row.classList.contains('unread')) {
          row.classList.remove('unread');
          const checkbox = row.querySelector('.messages-inbox-row-checkbox-input');
          if (checkbox) checkbox.dataset.mfuStatus = 'read';
        }

        const previewStats = messagesInboxReadPreviewStats(detailPanel);
        if (previewStats) {
          messagesInboxApplyStats(root, previewStats);
        }
        if (inboxTab === 'in') {
          messagesInboxFetchStats(root);
        }
      })
      .catch(() => {
        detailPanel.innerHTML = '<p class="smallinfo">Nachricht konnte nicht geladen werden.</p>';
      })
      .finally(() => {
        messagesInboxHideInlineLoading(detailLoading, detailPanel);
      });
  }

  function runSearch() {
    if (!searchForm) return;

    const params = messagesInboxBuildListParams(root, searchForm, 1);
    messagesInboxShowInlineLoading(listLoading, listPanel);

    fetch(`/messages/inbox/list?${params.toString()}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.text())
      .then((html) => {
        const extracted = messagesInboxExtractListHtml(html);
        listPanel.innerHTML = extracted.html;
        messagesInboxUpdateLoadMore(root, extracted.info);
        history.replaceState(null, '', `${searchForm.action}?${params.toString()}`);
        messagesInboxUpdateBulkToolbar(root);
      })
      .finally(() => {
        messagesInboxHideInlineLoading(listLoading, listPanel);
      });
  }

  if (listPanel.dataset.bound !== '1') {
    listPanel.dataset.bound = '1';
    listPanel.addEventListener('click', function (event) {
      if (event.target.closest('.messages-inbox-row-checkbox-input')) return;
      const row = event.target.closest('.messages-inbox-row');
      if (!row) return;
      event.preventDefault();
      loadPreview(row.dataset.previewUrl, row);
    });
    listPanel.addEventListener('change', function (event) {
      if (event.target.matches('.messages-inbox-row-checkbox-input')) {
        messagesInboxUpdateBulkToolbar(root);
      }
    });
  }

  if (root.dataset.bulkBound !== '1') {
    root.dataset.bulkBound = '1';

    root.querySelector('.messages-inbox-select-all-link')?.addEventListener('click', function (event) {
      event.preventDefault();
      listPanel.querySelectorAll('.messages-inbox-row-checkbox-input').forEach((box) => {
        box.checked = true;
      });
      const selectAll = root.querySelector('.messages-inbox-select-all');
      if (selectAll) selectAll.checked = true;
      messagesInboxUpdateBulkToolbar(root);
    });

    root.querySelector('.messages-inbox-select-none-link')?.addEventListener('click', function (event) {
      event.preventDefault();
      listPanel.querySelectorAll('.messages-inbox-row-checkbox-input').forEach((box) => {
        box.checked = false;
      });
      const selectAll = root.querySelector('.messages-inbox-select-all');
      if (selectAll) {
        selectAll.checked = false;
        selectAll.indeterminate = false;
      }
      messagesInboxUpdateBulkToolbar(root);
    });

    root.querySelector('.messages-inbox-select-all')?.addEventListener('change', function (event) {
      const checked = event.target.checked;
      listPanel.querySelectorAll('.messages-inbox-row-checkbox-input').forEach((box) => {
        box.checked = checked;
      });
      messagesInboxUpdateBulkToolbar(root);
    });

    root.querySelector('.messages-inbox-bulk-mark-read')?.addEventListener('click', function () {
      messagesInboxRunBulkAction(root, 'mark_read');
    });
    root.querySelector('.messages-inbox-bulk-mark-unread')?.addEventListener('click', function () {
      messagesInboxRunBulkAction(root, 'mark_unread');
    });
    root.querySelector('.messages-inbox-bulk-delete')?.addEventListener('click', function () {
      if (!window.confirm('Ausgewählte Nachrichten wirklich löschen?')) return;
      messagesInboxRunBulkAction(root, 'delete');
    });
  }

  if (root.dataset.detailActionsBound !== '1') {
    root.dataset.detailActionsBound = '1';
    root.addEventListener('click', function (event) {
      const maximizeButton = event.target.closest('.messages-inbox-maximize-button');
      if (maximizeButton) {
        event.preventDefault();
        messagesInboxOpenMaximizeModal(root, detailPanel);
      }
    });
  }

  root.querySelectorAll('.messages-inbox-filters .clickable_text').forEach((link) => {
    link.addEventListener('click', () => messagesInboxTabShowLoading(inboxTab));
  });

  if (searchForm && searchInput && searchForm.dataset.bound !== '1') {
    searchForm.dataset.bound = '1';
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      runSearch();
    });
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(runSearch, 300);
    });
  }

  if (root.dataset.loadMoreBound !== '1') {
    root.dataset.loadMoreBound = '1';
    root.addEventListener('click', function (event) {
      const loadMoreLink = event.target.closest('.messages-inbox-load-more');
      if (!loadMoreLink || !searchForm) return;
      event.preventDefault();

      const page = loadMoreLink.dataset.page;
      const params = messagesInboxBuildListParams(root, searchForm, page);
      if (root.dataset.unreadOnly === 'true') {
        params.set('unread_only', 'true');
      }

      messagesInboxShowInlineLoading(listLoading, listPanel);

      fetch(`/messages/inbox/list?${params.toString()}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => response.text())
        .then((html) => {
          const extracted = messagesInboxExtractListHtml(html);
          listPanel.insertAdjacentHTML('beforeend', extracted.html);
          messagesInboxUpdateLoadMore(root, extracted.info);
          messagesInboxUpdateBulkToolbar(root);
        })
        .finally(() => {
          messagesInboxHideInlineLoading(listLoading, listPanel);
        });
    });
  }

  messagesInboxUpdateBulkToolbar(root);

  if (selectedId) {
    const row = listPanel.querySelector(`.messages-inbox-row[data-message-id="${selectedId}"]`);
    if (row) {
      loadPreview(row.dataset.previewUrl, row);
    } else {
      const firstRow = listPanel.querySelector('.messages-inbox-row');
      if (firstRow) loadPreview(firstRow.dataset.previewUrl, firstRow);
    }
  } else {
    const firstRow = listPanel.querySelector('.messages-inbox-row');
    if (firstRow) loadPreview(firstRow.dataset.previewUrl, firstRow);
  }
}

window.initMessagesInbox = initMessagesInbox;
window.messagesInboxTabShowLoading = messagesInboxTabShowLoading;
window.messagesInboxTabHideLoading = messagesInboxTabHideLoading;

export { initMessagesInbox, messagesInboxTabShowLoading, messagesInboxTabHideLoading };
